import React, { PropsWithChildren } from 'react';
import { ModusWcMenuItem } from '@trimble-oss/moduswebcomponents-react';
import { ModusSize } from '@trimble-oss/moduswebcomponents';

export type MenuItemEvent = (event: CustomEvent<{ value: string }>) => void;
export type ToopTipPosition = 'auto' | 'top' | 'right' | 'bottom' | 'left';

export interface MenuItemProps extends React.ComponentProps<typeof ModusWcMenuItem> {
  bordered?: boolean;
  /**
   * If true, renders a checkbox at the start of the menu item.
   */
  checkbox?: boolean;
  /**
   * Custom CSS class to apply to the li element.
   */
  customClass?: string;
  /**
   * The disabled state of the menu item.
   */
  disabled?: boolean;
  /**
   * The focused state of the menu item.
   */
  focused?: boolean;
  /**
   * The text rendered in the menu item.
   */
  label: string;
  /**
   * The selected state of the menu item.
   */
  selected?: boolean;
  /**
   * The size of the menu item.
   */
  size?: ModusSize;
  /**
   * The modus icon name to render on the start of the menu item.
   */
  startIcon?: string;
  /**
   * The text rendered beneath the label.
   */
  subLabel?: string;
  /**
   * The tooltip text to display when hovering over the menu item.
   */
  tooltipContent?: string;
  /**
   * The position of the tooltip relative to the menu item.
   */
  tooltipPosition?: ToopTipPosition;
  /**
   * The unique identifying value of the menu item.
   */
  value: string;

  onItemSelect?: MenuItemEvent;
}

// Wrapper component with all types added
export const MenuItem: React.FC<PropsWithChildren<MenuItemProps>> = (props) => {
  return <ModusWcMenuItem {...props}>{props.children}</ModusWcMenuItem>;
};
